import { render, staticRenderFns } from "./AnonymousMigration.vue?vue&type=template&id=20776b92"
import script from "./AnonymousMigration.vue?vue&type=script&lang=js"
export * from "./AnonymousMigration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports